<script lang="ts">
    import { wishlistQualified } from '@tilelist/domain/feature-visibility/WishlistVisibility.ts';

    interface Props {
        variationId: string;
        multipleSizes?: boolean;
    }

    let { variationId, multipleSizes }: Props = $props();
    const qualified = $derived(wishlistQualified(multipleSizes));
</script>

<div class="reptile-wishlist-icon">
    <ofc-wishlist-save-button-v1 variation-id={variationId} {qualified} source="ProductList"
    ></ofc-wishlist-save-button-v1>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    .reptile-wishlist-icon {
        /*                                                                                */
        /*                                                                           */
        /*                                                                                    */
        pointer-events: auto;

        position: absolute;
        z-index: 1;
        top: tokens.$oc-semantic-spacing-absolute-25;
        right: tokens.$oc-semantic-spacing-absolute-25;
    }
</style>
